export default __webpack_public_path__ + "static/media/FP_Logo_with_slogan_White.9a9f28e1.png";